import { render, staticRenderFns } from "./TurnoverRebate.vue?vue&type=template&id=a8de384a&"
import script from "./TurnoverRebate.vue?vue&type=script&lang=js&"
export * from "./TurnoverRebate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports